import { Role } from '../types/venture';
export const credentials = ['SEBI Registered Investment Advisor', 'Certified Financial Planner (CFP)', 'Qualified Personal Finance Professional (QPFP®)', 'Independent Director', 'Equity Portfolio Management'];
export const services = ['Financial planning', 'Investment planning & management', 'Estate planning', 'Tax planning'];
export const currentRoles: Array<Role & {
  summary: string;
  points: string[];
}> = [{
  id: 'prosperr',
  company: 'Prosperr.io',
  title: 'Director — Wealth | Head of New Initiatives',
  years: "Apr 2025 — August 2026",
  place: "Bengaluru",
  summary: 'Building the wealth management vertical from the ground up.',
  points: ['Established the wealth management vertical, focused on innovative client advisory services.', 'Built and led a team of wealth advisors and associates around client engagement.', 'Wrote the investment management and advisory processes, with regulatory compliance built in.']
}, {
  id: 'sekhi-capital-role',
  company: 'Sekhi Capital',
  title: 'Principal — Investment Advisor',
  years: 'Jan 2021 — now',
  place: 'Chennai',
  summary: 'My own practice: advice and investment management for families and founders.',
  points: ['SEBI Registered Investment Advisor running financial advisory and investment management.', 'Financial, investment, estate and tax planning under one relationship.']
}];

/** Numbers from leading investments at Liquide (2023 — 2025). */
export const numbers = [{
  value: '$1.6B',
  label: 'Assets advised'
}, {
  value: '₹1,000 Cr',
  label: 'Multi-asset book built in 10 months'
}, {
  value: '4,000+',
  label: 'Client portfolios reviewed'
}, {
  value: '₹100 Cr+',
  label: 'Equity baskets managed'
}];
export const priorRoles: Role[] = [{
  id: 'liquide',
  company: 'Liquide',
  title: 'Head of Investments',
  years: '2023 — 2025',
  place: 'Bengaluru'
}, {
  id: 'blomdahl',
  company: 'Blomdahl & Bromandi',
  title: 'Venture Advisor',
  years: '2015 — 2017',
  place: 'Gothenburg'
}, {
  id: 'breakit',
  company: 'Breakit',
  title: 'Community Manager — Swedish startup space',
  years: '2015',
  place: 'Gothenburg'
}, {
  id: 'tedx',
  company: 'TEDxGöteborg',
  title: 'Project Team Member',
  years: '2014 — 2015',
  place: 'Göteborg'
}, {
  id: 'medifactia',
  company: 'Medifactia',
  title: 'Market Analyst',
  years: '2014',
  place: 'Gothenburg'
}, {
  id: 'birla',
  company: 'Aditya Birla Group',
  title: 'Project Engineer — Technical R&D',
  years: '2011 — 2012',
  place: 'India'
}, {
  id: 'bcd',
  company: 'BCD Barcelona Centre de Disseny',
  title: 'Research Intern',
  years: '2011',
  place: 'Barcelona'
}];
export const education = {
  school: 'Chalmers University of Technology',
  degree: 'MSc, Management & Economics',
  place: 'Gothenburg, Sweden'
};
export const honors = ['Next Generation Future Global Leader', 'Adlerbert Scholarship', 'Academic Scholarship', 'Dean’s List Certificate', 'Merit List Certificate'];
export interface Publication {
  id: string;
  title: string;
  journal: string;
  date: string;
  abstract: string;
  href: string;
}
export const publications: Publication[] = [{
  id: 'counting-out',
  title: 'Message Guided Adaptive Random Steganography using Counting-out Embedding',
  journal: 'International Journal of Computer Applications',
  date: 'Jul 1, 2011',
  abstract: 'Digital data protection turns out to be the most essential constituent in the cyber world where digital crime is mounting to its worst. To establish secured data communication a technique called Steganography, one of the fruitful attempts for data hiding, has evolved. The rationale of this scheme is to blot out the message in to an innocuous cover media. For good stego system imperceptibility, randomization and capacity are the important considerations. In this paper we propose a novel keyless random algorithm in image steganography which induces an enhanced security by incorporating “counting-out” embedding. It uses message bits embedded in the current pixel which acts as a key for the next pixel to which data is to be embedded. This method provides adaptive randomization without affecting the imperceptibility and capacity.',
  href: 'https://www.ijcaonline.org/archives/volume24/number6/2949-3951/'
}, {
  id: 'significant-nibble',
  title: 'Adaptive Randomization in Image Steganography Pertaining to Most Significant Nibble',
  journal: 'International Journal of Computer Applications',
  date: 'May 31, 2011',
  abstract: 'With innovations ruling the world, there has been a phenomenal growth of e-commerce leading to a lot of transactions taking place online in Internet. To safely transfer data, an existing technique called steganography is used. The goal of steganography is to insert a message into a carrier signal so that it can’t be detected by unintended recipients. Images, video, and audio being the widespread carrier media, steganalysis attempts to discover hidden messages in suspected covers are at the least detectable when they are more randomized. Therefore one of the important considerations in steganography is to have a meliorated randomization technique. To provide better randomization we propose few techniques in image steganography which use adaptive way of randomization by embedding the data in to the bits of “least significant nibble” pertaining to bits in “most significant nibble”.',
  href: 'https://www.ijcaonline.org/archives/volume22/number3/2567-3529/'
}];
export const languages = [{
  name: 'English',
  level: 'Full professional'
}, {
  name: 'Hindi',
  level: 'Full professional'
}, {
  name: 'Tamil',
  level: 'Full professional'
}, {
  name: 'Konkani',
  level: 'Full professional'
}, {
  name: 'Swedish',
  level: 'Elementary'
}, {
  name: 'Spanish',
  level: 'Elementary'
}];